export const REIMBURSEMENT_RATES_GET_REIMBURSEMENT_RATES =
  'REIMBURSEMENT_RATES_GET_REIMBURSEMENT_RATES';
export const REIMBURSEMENT_RATES_FETCHING = 'REIMBURSEMENT_RATES_FETCHING';
export const REIMBURSEMENT_RATES_FETCH_ERROR =
  'REIMBURSEMENT_RATES_FETCH_ERROR';
export const REIMBURSEMENT_RATES_CLEAR_FETCH_ERROR =
  'REIMBURSEMENT_RATES_CLEAR_FETCH_ERROR';
export const REIMBURSEMENT_RATES_SET_REIMBURSMENT_RATE =
  'REIMBURSEMENT_RATES_SET_REIMBURSMENT_RATE';
export const REIMBURSEMENT_RATE_SAVEFIELDS = 'REIMBURSEMENT_RATE_SAVEFIELDS';
export const REIMBURSEMENT_RATE_SETSUCCESS = 'REIMBURSEMENT_RATE_SETSUCCESS';
export const REIMBURSEMENT_RATE_SET_FORM_DATA_BY_ID =
  'REIMBURSEMENT_RATE_SET_FORM_DATA';
export const REIMBURSEMENT_RATE_SET_FORM_DATA =
  'REIMBURSEMENT_RATE_SET_FORM_DATA';
export const REIMBURSEMENT_RATE_CLEAR_FORM_DATA =
  'REIMBURSEMENT_RATE_CLEAR_FORM_DATA';
export const REIMBURSEMENT_RATE_CANCEL_CHANGE =
  'REIMBURSEMENT_RATE_CANCEL_CHANGE';



// WEBPACK FOOTER //
// ./src/pages/reimbursementrates/state/rates/types.js